// effects for application insights
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { InsightsApiService } from '@app/services/insights-api.service';
import * as KeywordsActions from './actions';

@Injectable()
export class KeywordsEffects {

  constructor(
    private actions$: Actions,
    private insightsApiService: InsightsApiService
  ) {}

  /**
   * Get insights keyword list from database.
   *
   * @memberof KeywordsEffects
   */
  getInsightsKeywords$ = createEffect(() => 
    this.actions$.pipe(
      ofType(KeywordsActions.getInsightsKeywords),
      mergeMap(() => 
        this.insightsApiService.getKeyWords().pipe(
          map(keywords => KeywordsActions.getInsightsKeywordsSuccess({keywords})),
          catchError(error => of(KeywordsActions.getInsightsKeywordsFailure({error})))
        )
      )
    )
  );

  /**
   * Add insights keyword into database.
   *
   * @memberof KeywordsEffects
   */
  addKeyword$ = createEffect(() => 
    this.actions$.pipe(
      ofType(KeywordsActions.addInsightsKeyword),
      mergeMap(action => 
          this.insightsApiService.addKeyword(action.keyword).pipe(
            map(response => KeywordsActions.addInsightsKeywordSuccess({message: response.message})),
            catchError(error => of(KeywordsActions.addInsightsKeywordError({ error })))
          )
        )
      )
    );
    
}